var _defs, _polygon, _polyline, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpcWick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a2834;}.cls-2{fill:aqua;}.cls-3{fill:#33222e;}.cls-4{fill:#2d1f29;}.cls-5{fill:#4c3547;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250.54 283.17 455.62 283.17 504.04 444.16 202.82 444.56 250.54 283.17"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "250.81 283.09 353.34 240.72 455.87 283.28"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "212.29 463.53 491.94 463.53 504.04 444.16 202.6 444.16 212.29 463.53"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "298.88 498.12 406.01 498.12 419.43 473.84 286.56 473.84 298.88 498.12"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "252.12 481.37 452.12 481.37 465.92 462.93 240.74 462.93 252.12 481.37"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "316.48 444.93 202.43 444.56 245.73 208.52 292.33 253.43 316.48 444.93"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "390.17 444.93 504.22 444.56 460.92 208.52 414.31 253.43 390.17 444.93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpcWick);
export default __webpack_public_path__ + "static/media/npc-wick.38071a142ea1dbe64c802b030a334606.svg";
export { ForwardRef as ReactComponent };